import { UserItemDto } from '@/api/generated';
import { UsersListSearchFormModel } from '@/views/users/list/model/UsersListSearchForm.model.ts';

type FormType = Record<keyof UserItemDto, string>;

const Form: FormType = {
  email: 'Email',
  enabled: 'Aktywne',
  externalUserId: '',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  phone: 'Telefon',
  role: 'Rola',
  userBusinessId: 'Identyfikator użytkownika',
  userId: '',
};

export type UsersListTranslation = {
  dialog: {
    create: {
      button: {
        cancel: string;
        create: string;
      };
      form: FormType;
      title: string;
    };
    edit: {
      button: {
        cancel: string;
        save: string;
      };
      form: FormType;
      permissionGrants: {
        ariaLabel: string;
        grantedCount: string;
        heading: string;
        loadError: string;
        loading: string;
        noRole: string;
        readOnly: string;
        rolePermissions: string;
      };
      tabs: {
        ariaLabel: string;
        details: string;
        permissionGrants: string;
      };
      title: string;
    };
  };
  table: {
    addUser: string;
    body: FormType;
    head: Record<keyof UsersListSearchFormModel, string>;
  };
};

export const usersListTranslation: UsersListTranslation = {
  dialog: {
    create: {
      button: {
        cancel: 'Anuluj',
        create: 'Dodaj',
      },
      form: Form,
      title: 'Nowy użytkownik',
    },
    edit: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: Form,
      permissionGrants: {
        ariaLabel: 'Macierz uprawnień dodatkowych użytkownika',
        grantedCount: 'Nadane dodatkowo: {{granted}} z {{total}}',
        heading: 'Uprawnienia dodatkowe',
        loadError: 'Nie udało się wczytać uprawnień dodatkowych. Spróbuj ponownie.',
        loading: 'Wczytywanie uprawnień dodatkowych',
        noRole:
          'Użytkownik nie ma roli, więc czeka na zatwierdzenie konta — uprawnienia dodatkowe zadziałają po nadaniu roli.',
        readOnly:
          'Podgląd — nie masz uprawnienia do edycji ról, więc nie zmienisz uprawnień dodatkowych.',
        rolePermissions:
          'Uprawnienia oznaczone „z roli” daje rola „{{role}}”; zmienisz je na stronie „Role i uprawnienia”.',
      },
      tabs: {
        ariaLabel: 'Sekcje edycji użytkownika',
        details: 'Dane konta',
        permissionGrants: 'Uprawnienia dodatkowe',
      },
      title: 'Aktualizacja konta',
    },
  },
  table: {
    addUser: 'Dodaj użytkownika',
    body: Form,
    head: {
      fullTextSearchInput: 'Wyszukaj użytkownika',
    },
  },
};
